import { APIConfiguration } from '@savgroup-front-common/configuration';
import { HANDLING_GROUPS } from '@savgroup-front-common/constants';
import { TransportPlan } from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';

export const getUrlLogoSeller = ({ sellerId }: { sellerId?: string }) => {
  return `${APIConfiguration.imageCDN}sellers/${sellerId}.png`;
};

export const getUrlLogoCarrier = ({
  sellerId,
  transportPlan,
}: {
  sellerId?: string;
  transportPlan: TransportPlan;
}) => {
  const carrierName = transportPlan.carrier
    ? transportPlan.carrier.toLowerCase()
    : HANDLING_GROUPS.EXTERNAL.toLowerCase();

  if (!sellerId) {
    return [
      `${APIConfiguration.catalogCDN}carriers/${carrierName}.png`,
      `${APIConfiguration.catalogCDN}carriers/${carrierName}.svg`,
    ];
  }

  return [
    `${APIConfiguration.imageCDN}sellers/${sellerId}/${carrierName}.png`,
    `${APIConfiguration.catalogCDN}carriers/${carrierName}.png`,

    `${APIConfiguration.imageCDN}sellers/${sellerId}/${carrierName}.svg`,
    `${APIConfiguration.catalogCDN}carriers/${carrierName}.svg`,
  ];
};
